<!--
    IntegrationTypeStepObjectBaseComponent Template

    Delegates rendering to mode-specific view components based on uiMode.
    - 'side' mode: Renders IntegrationTypeStepSideComponent for panel/drawer display
    - default: Renders IntegrationTypeStepFullComponent for full-page display

    @input objectIdentifier - The object identifier for the IntegrationTypeStep entity
    @input uiMode - The UI mode ('side' | 'full')
    @output onNavigationItems - Emits navigation items from child components
-->
@if (initialized && dto) {
    @if (uiMode == 'side') {
        <hc-integration-type-step-side-component
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></hc-integration-type-step-side-component>
    } @else {
        <hc-integration-type-step-full-component
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></hc-integration-type-step-full-component>
    }
}
